import { useAuthStore } from '../stores/auth'
import { createFetch } from '@vueuse/core'
export const useApi = () => {
  const authStore = useAuthStore()

  return createFetch({
    baseUrl: import.meta.env.VITE_API_BASE,
    combination: 'chaining',
    options: {
      beforeFetch({ options }) {
        if (authStore.token)
          options.headers.Authorization = `Bearer ${authStore.token}`
        return { options }
      },
      onFetchError(ctx) {
        switch (ctx.response?.status) {
          case 401:
            authStore.logout()
            break
          default:
            ctx.error = ctx.data?.message || ctx.error
            break
        }
        return ctx
      }
    }
    // fetchOptions: {
    //   mode: 'no-cors'
    // }
  })
}
